import { useCheckUserPermissions } from '@hooks/checkUserPermisions';
import { useApi } from '@hooks/useApi';
import { MerchantLink } from '@root/globalTypes';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';

export function useMerchantLinkList({ merchantId }: { merchantId: string }) {
  const { isLogged } = useCheckUserPermissions();
  const { query } = useApi();

  const { data, isPending } = useQuery<MerchantLink[]>({
    queryKey: [...queryKeys.merchantLinks, merchantId, window.location.search],
    queryFn: (): Promise<MerchantLink[]> =>
      query({
        path: `v1/staff/merchants/${merchantId}/links${window.location.search}`,
      }),
    placeholderData: (previousValue) => previousValue,
    enabled: isLogged,
  });

  return {
    data: data || [],
    isPending,
  };
}
